import React from 'react';
import {Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import SectionCard from './SectionCard';
import settingsStyles from '../settingsStyles';
import {buildHealthChecks, calculateHealthScore, CHECK_STATUS} from '../healthScore';
import {
    WEB_BLOG_LIST,
    WEB_FAQ_LIST,
    WEB_POPUP_LIST,
    WEB_EDIT_SHORT,
} from '../../../../../constants/appUrls.constants';

// Eksik alan hangi ekranda tamamlaniyorsa oraya goturur.
const targetLink = (target, webId) => {
    if (target === 'blog') return WEB_BLOG_LIST;
    if (target === 'faq') return WEB_FAQ_LIST;
    if (target === 'popup') return WEB_POPUP_LIST;
    return webId ? WEB_EDIT_SHORT + webId : null;
};

const scoreColor = (score) => {
    if (score >= 80) return '#157f4f';
    if (score >= 50) return '#a86200';
    return '#d71f26';
};

export default function HealthScoreCard({editWebData, extras, webId}) {
    const {t} = useTranslation();
    const classes = settingsStyles();

    const checks = buildHealthChecks(editWebData, extras);
    const score = calculateHealthScore(checks);
    const color = scoreColor(score);

    // Opsiyonel alanlar (orn. kapak videosu) eksik sayilmaz
    const incomplete = checks.filter((check) => !check.optional && check.status !== CHECK_STATUS.DONE);

    const markClass = {
        [CHECK_STATUS.DONE]: classes.checkMarkDone,
        [CHECK_STATUS.PARTIAL]: classes.checkMarkPartial,
        [CHECK_STATUS.MISSING]: classes.checkMarkMissing,
    };

    const markIcon = {
        [CHECK_STATUS.DONE]: 'fas fa-check',
        [CHECK_STATUS.PARTIAL]: 'fas fa-minus',
        [CHECK_STATUS.MISSING]: 'fas fa-times',
    };

    return (
        <SectionCard
            id="durum"
            icon="fas fa-tachometer-alt"
            title={t('enw-web-settings-health_title', 'Bilgi Doğruluk Oranı')}
            description={t('enw-web-settings-health_desc', 'Sitenizin ne kadarının dolu olduğunu gösterir')}
        >
            <div className={classes.health}>
                <div className={classes.gauge}>
                    <div
                        className={classes.ring}
                        style={{background: `conic-gradient(${color} 0 ${score}%, #f1f4f9 ${score}% 100%)`}}
                    >
                        <div className={classes.ringValue}>
                            <span className={classes.ringNumber} style={{color}}>{score}</span>
                            <span className={classes.ringLabel}>
                                {t('enw-web-settings-health_gauge', 'Doluluk')}
                            </span>
                        </div>
                    </div>
                    <p className={classes.gaugeCaption}>
                        {incomplete.length > 0
                            ? t('enw-web-settings-health_caption', {
                                defaultValue: '{{count}} alan eksik. Tamamladıkça arama motorlarındaki sıranız yükselir.',
                                count: incomplete.length,
                            })
                            : t('enw-web-settings-health_complete', 'Tüm alanlar dolu. Siteniz yayına tam hazır.')}
                    </p>
                </div>

                <div className={classes.checkGrid}>
                    {checks.map((check) => {
                        const link = check.status === CHECK_STATUS.DONE ? null : targetLink(check.target, webId);
                        // Opsiyonel ve bos alan uyari gibi degil, notr bir oneri gibi okunmali
                        const isOptionalEmpty = check.optional && check.status !== CHECK_STATUS.DONE;
                        return (
                            <div className={classes.check} key={check.key}>
                                <span className={`${classes.checkMark} ${markClass[check.status]}`}>
                                    <i className={isOptionalEmpty ? 'fas fa-minus' : markIcon[check.status]} />
                                </span>
                                <span
                                    className={`${classes.checkName} ${
                                        check.status === CHECK_STATUS.MISSING ? classes.checkNameMissing : ''
                                    }`}
                                >
                                    {t(check.label, check.fallback)}
                                </span>
                                {link && (
                                    <Link
                                        className={`${isOptionalEmpty ? classes.linkishMuted : classes.linkish} ${classes.checkAction}`}
                                        to={link}
                                    >
                                        {check.status === CHECK_STATUS.MISSING
                                            ? t('enw-web-settings-add', 'Ekle')
                                            : t('enw-web-settings-complete', 'Tamamla')}
                                    </Link>
                                )}
                                <span className={classes.checkStatus}>
                                    {isOptionalEmpty
                                        ? t('enw-web-settings-optional', 'İsteğe bağlı')
                                        : check.value}
                                </span>
                            </div>
                        );
                    })}
                </div>
            </div>
        </SectionCard>
    );
}
